import {Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild, OnDestroy} from '@angular/core';
import {
    MatCheckboxChange,
    MatTabGroup
} from '@angular/material';
import {ConfirmTestcaseDeletionComponent, TestsuiteComponent} from '../testsuite/testsuite.component';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatDialogRef} from '@angular/material';
import {ConnecttocrudService} from '../connecttocrud.service';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {DevexListenerService} from '../devex-listener.service';
import {ActivatedRoute, Router} from '@angular/router';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {HeadersComponent} from '../devex/headers/headers.component';
import {ConfService} from '../conf.service';
import {FormBuilder} from '@angular/forms';
import {Location} from '@angular/common';
import {AuthorizationComponent} from '../authorization/authorization.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {TestsuiteListenerService} from '../testsuite-listener.service';
import {TestcaseInteractionService} from '../services/testcase-interaction.service'
import { Subscription } from 'rxjs';

export interface TestCaseData {
    name: string;
    type: string;
}

declare let $;

@Component({
    selector: 'app-testcase',
    templateUrl: './testcase.component.html',
    styleUrls: ['./testcase.component.scss']
})


export class TestcaseComponent implements OnInit, OnDestroy {

    isLinear = true;
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    @Input() executor_name = '';
    @Input() executor_version = '';
    @Input() editFlag: boolean;
    testCasesSearchText: any;
    columns = [];
    parameters = [];
    showParameters = false;
    templateParameters = [];
    recipientSpecificParameters = [];

    recipientSpecificParametersPayload = [];
    dummyPayload = {};
    count = 0;

    httpOperation: any;
    httpOperations = [
        {'name': 'GET'},
        {'name': 'POST'},
        {'name': 'PUT'},
        {'name': 'PATCH'},
        {'name': 'DELETE'}
    ];
    httpUrl: string;
    parametersHeaders = ['key', 'value', 'description'];
    parameterData = [];
    pathParameter = [];
    headersData = [];
    formData = [];
    requestBodySelected = 'none';
    confirmationWithoutResponseAttributes = {confirmation: ''};
    requestBodyTypes = [
        {'displayName': 'None', 'value': 'none'},
        {'displayName': 'Form Data', 'value': 'form-data'},
        {'displayName': 'Form URL Encoded', 'value': 'x-www-form-urlencoded'},
        {'displayName': 'Raw', 'value': 'raw'},
        {'displayName': 'Binary / File', 'value': 'binary'}

    ];

    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    @ViewChild(AuthorizationComponent) authModel1: AuthorizationComponent;
    @ViewChild(HeadersComponent) headerChild: HeadersComponent;
    @ViewChild('tabref4') tabref4: MatTabGroup;
    @Output() onCompletingTestCases: EventEmitter<any> = new EventEmitter<any>();

    private subscription: Subscription;
    options1 = new JsonEditorOptions();

    showPathParameters: boolean;
    devExURL = '';
    isCountOfResAtt: boolean;
    pathParameterSegregator: any;
    find: any;
    pathParameterStopper: any;
    pathParameterValue: any;

    requestBody: any;
    rawRequestBody: any;

    authAttributes = {};
    authModel = {
        'authAttributes': this.authAttributes
    };

    formDataTrue = true;
    formURLEncodedTrue = true;

    responseData: any;
    errorMessage: any;
    responseError: any;

    executorName: string;
    executorVersion: string;
    executor_url: string;
    executor_type = 'API';
    executor_method_type: string;
    executors: any;

    apiByDefinition: any;
    categories: any;
    entities = [];

    APIExecutorCategory = [];
    businessLogicAPIExecutorCategory = [];
    thirdPartyAPIExecutorCategory = [];
    SQLQueryAPIExecutorCategory = [];
    WorkflowAPIExecutorCategory = [];

    DataAccessAPIByCategory = [];
    businessLogicAPIByCategory = [];
    thirdPartyAPIByCategory = [];
    SQLQueryAPIByCategory = [];
    WorkflowAPIByCategory = [];

    basicPermission: boolean;

    DisplayApiByCategory = true;

    APITypes = [
        {
            type: 'Data Access API',
            category: this.APIExecutorCategory
        },
        {
            type: 'Business Logic API',
            category: this.businessLogicAPIExecutorCategory
        },
        {
            type: 'Third Party API',
            category: this.thirdPartyAPIExecutorCategory
        },
        {
            type: 'SQL Query API',
            category: this.SQLQueryAPIExecutorCategory
        },
        {
            type: 'Workflow API',
            category: this.WorkflowAPIExecutorCategory
        }
    ];

    delimiters = [
        {
            delimiter: ':'
        },
        {
            delimiter: ','
        }
    ];
    selectedDelimiter = ',';

    commaSeparatedList: any;

    DAASExecutors: any;
    businessLogicExecutors: any;
    sqlQueryExecutors: any;
    workFlowExecutors: any;

    apisByCategory: any;
    dataAccess = [];
    businessLogic = [];
    sql = [];
    workflow = [];
    decision = [];
    thirdparty = [];

    DisplayCustomOperation = true;
    executor: any;

    headers = [];
    queryParams = [];
    prerequisites: any;
    showAPIBrowser = true;

    itemList = [];
    filterData: any[];
    settings = {
        text: 'Select attribute(s) to search instantly',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
    searchText: string;
    subscriberColumns = [];
    subscribersColumnsLength: number;
    subscribersData: any;
    selectAll = false;
    subscribersChecked = [];
    settingsData: any;
    rightOperandType = [];
    jsonEditorData = [];

    readonly separatorKeysCodes: number[] = [ENTER, COMMA];

    constructor(private _service: ConnecttocrudService, public platform: LeftpanelComponent, public devexListenerInstance: DevexListenerService, public router: Router, public suite: TestsuiteComponent,
                public dialog: MatDialog, private route: ActivatedRoute, private confPost: ConfService, private _formBuilder: FormBuilder, private location: Location, private testSuiteListenerInstance: TestsuiteListenerService,
                private testcaseInteractionService: TestcaseInteractionService) {
        this.options1.mode = 'code';
        this.options1.modes = ['code', 'text', 'tree', 'view'];
        this.options1.schema = '';
        this.options1.statusBar = false;
        this.options1.onChange = () => console.log( /*this.editor.get()*/);
    }

    @Input() testcase = [];
    @Output() onExecutionComplete = new EventEmitter<string>();
    responses: any;
    responseItems: any;
    @Output() onAddingTestCase: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCompletingTearDownSteps: EventEmitter<any> = new EventEmitter<any>();
    Index = 0;
    testCaseName = '';
    currentTestCaseName = '';
    currentTestCaseIndex = 0;
    assert = [];
    steps = {};
    leftOperand = [
        {
            name: 'response',
            value: ''
        },
        {
            name: 'response.body',
            value: ''
        },
        {
            name: 'response.statusCode',
            value: ''
        },
        {
            name: 'response.headers',
            value: ''
        },
    ];
    leftOperandString: string;
    rightOperand;
    operators = ['=', '≠', '<', '≤', '>', '≥'];

    ngOnInit() {

        this.getCategoriesEntitiesForPartner();
        this.getBusinessLogicApiExecutorsByPartnerAccountType();
        this.getThirdPartyApiExecutorsByPartnerAccountType();
        this.getSqlQueryApiExecutorsByPartnerAccountType();
        this.getWorkFlowApiExecutorsByPartnerAccountType();
        this.basicPermission = true;

        // this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'))
        //     .toPromise().then(data => {
        //     let apiExecutors: any;
        //     apiExecutors = data;
        //     const tempCategoryarray = [];
        //     const tempCategoryarray1 = [];
        //     const tempCategoryarray2 = [];
        //     const tempCategoryarray3 = [];
        //
        //     for (let i = 0; i < apiExecutors.length; i++) {
        //         for (let j = 0; j < apiExecutors[i]['executors'].length; j++) {
        //             switch (apiExecutors[i]['executors'][j]['executor_type']) {
        //                 case 'API':
        //                     const apiName = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
        //                     if (tempCategoryarray.includes(apiName) === false) {
        //                         tempCategoryarray.push(apiName);
        //                         this.APIExecutorCategory.push(
        //                             {
        //                                 'category': apiExecutors[i]['executors'][j]['executor_category'],
        //                                 'version': apiExecutors[i]['executors'][j]['executor_version'],
        //                                 'categoryAndVersion': apiName
        //                             });
        //                         this.DataAccessAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
        //                     }
        //                     break;
        //                 case 'WORKFLOW':
        //                     const apiName1 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
        //                     if (tempCategoryarray1.includes(apiName1) === false) {
        //                         tempCategoryarray1.push(apiName1);
        //                         this.WorkflowAPIExecutorCategory.push(
        //                             {
        //                                 'category': apiExecutors[i]['executors'][j]['executor_category'],
        //                                 'version': apiExecutors[i]['executors'][j]['executor_version'],
        //                                 'categoryAndVersion': apiName1
        //                             });
        //                         this.WorkflowAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
        //                     }
        //                     break;
        //                 case 'BUSINESSLOGIC':
        //                     const apiName2 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
        //                     if (tempCategoryarray2.includes(apiName2) === false) {
        //                         tempCategoryarray2.push(apiName2);
        //                         this.businessLogicAPIExecutorCategory.push(
        //                             {
        //                                 'category': apiExecutors[i]['executors'][j]['executor_category'],
        //                                 'version': apiExecutors[i]['executors'][j]['executor_version'],
        //                                 'categoryAndVersion': apiName2
        //                             });
        //                         this.businessLogicAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
        //                     }
        //                     break;
        //                 case 'SQLQUERY':
        //                     const apiName3 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
        //                     if (this.businessLogicAPIExecutorCategory.includes(apiName3) === false) {
        //                         tempCategoryarray3.push(apiName3);
        //                         this.businessLogicAPIExecutorCategory.push(
        //                             {
        //                                 'category': apiExecutors[i]['executors'][j]['executor_category'],
        //                                 'version': apiExecutors[i]['executors'][j]['executor_version'],
        //                                 'categoryAndVersion': apiName3
        //                             });
        //                         this.SQLQueryAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
        //                     }
        //                     break;
        //
        //             }
        //         }
        //     }
        //
        // });

        this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account'))
            .subscribe(data => {
                if (data[0].accounts != null) {
                    data[0].accounts.forEach((accounts) => {
                        if (accounts.categories != null) {
                            this.categories = accounts.categories;
                            for (let i = 0; i < this.categories.length; i++) {
                                for (let j = 0; j < this.categories[i].entities.length; j++) {
                                    const tempJSON = {};
                                    tempJSON['entity'] = this.getEntity(this.categories[i].entities[j]);
                                    tempJSON['version'] = this.getVersion(this.categories[i].entities[j]);
                                    this.entities.push(tempJSON);
                                }
                            }
                        }
                    });
                }
            });

        this.apiByDefinition = [{
            'customType': false,
            'apiAccessPolicy': 'None',
            'attributeName': null,
            'type': null,
            'array': false,
            'size': null,
            'precision': null,
            'autoIncrement': false,
            'defaultValue': null,
            'attributeType': 'None',
            'dataStoragePolicy': 'None',
            'description': null,
            'displayName': null,
            'displayPolicy': 'None',
            'required': false,
            'subType': []

        }];

        this.Index = 0;
        for (const header of this.headersData) {
            if (header['key'] === 'Content-Type') {
                switch (header['value']) {
                    case 'multipart/form-data':
                        this.requestBodySelected = 'form-data';
                        break;
                    case 'application/x-www-form-urlencoded':
                        this.requestBodySelected = 'x-www-form-urlencoded';
                        break;
                    case 'application/json':
                        this.requestBodySelected = 'raw';
                        break;
                    default:
                        this.requestBodySelected = 'none';
                        break;
                }
            }
        }
        if (this.testcase.length) {
            this.setCurrentTestCase(this.currentTestCaseIndex);
        }
        this.subscription = this.testcaseInteractionService.executeApi$.subscribe(
            (context: string) => {
                this.executeApi(context);
            }
        );
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }


    showOptions(event: MatCheckboxChange, index): void {
        if (event.checked) {
            this.subscribersChecked.push(this.subscribersData[index]);
        } else {
            for (let i = 0; i < this.subscribersChecked.length; i++) {
                if (this.subscribersChecked[i]['email'] === this.subscribersData[index]['email']) {
                    this.subscribersChecked.splice(i, 1);
                }
            }
        }
    }

    getCategoriesEntitiesForPartner() {
        // if (this.categories.length === 0) {
        this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account'))
            .subscribe(data => {
                if (data[0].accounts != null) {
                    data[0].accounts.forEach((accounts) => {
                        if (accounts.categories != null) {
                            this.categories = accounts.categories;
                            if (this.categories && this.categories.length > 0) {
                                this.DisplayApiByCategory = true;
                                this.DisplayCustomOperation = true;
                            } else {
                                this.DisplayApiByCategory = false;
                                this.DisplayCustomOperation = false;
                            }
                        }
                    });
                }
            });
        // }
    }

    async getBusinessLogicApiExecutorsByPartnerAccountType() {
        if (this.platform.businessLogicExecutors !== null && this.platform.businessLogicExecutors !== undefined && this.platform.businessLogicExecutors !== '') {
            this.businessLogicExecutors = this.platform.businessLogicExecutors;
        } else {
            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.businessLogicExecutors = this.platform.businessLogicExecutors;
            });

            // await this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'BUSINESSLOGIC').toPromise().then(data => {
            //     this.businessLogicExecutors = data;
            //     this.platform.businessLogicExecutors = data;
            //     // localStorage.setItem('businessLogicAPI' , JSON.stringify(this.executors));
            // }, error => {
            //     this.platform.openSnackBar('Error while Business Logic APIs', 'Error', {
            //         duration: 5000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
        }

    }

    getThirdPartyApiExecutorsByPartnerAccountType() {
        // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'THIRDPARTY').subscribe(data => {
        //     this.thirdPartyApiExecutors = data;
        //     // localStorage.setItem('dataAccessAPI' , JSON.stringify(this.apiExecutors));
        // });
        this.confPost.getApiExecutorsForPartnerAccount(this.partner, this.account).subscribe(data => {
            // this.thirdPartyApiExecutors = data;
            this.apisByCategory = data;
            for (let i = 0; i < this.apisByCategory.length; i++) {
                const tempDataAccess = [];
                const tempbusinessLogic = [];
                const tempsql = [];
                const tempworkflow = [];
                const tempdecision = [];
                const tempthirdParty = [];
                for (let j = 0; j < this.apisByCategory[i]['executors'].length; j++) {
                    let temp: string;
                    temp = '';
                    if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'API') {
                        tempDataAccess.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'BUSINESSLOGIC') {
                        tempbusinessLogic.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'SQLQUERY') {
                        tempsql.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'WORKFLOW') {
                        tempworkflow.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'DECISION') {
                        tempdecision.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'THIRDPARTY') {
                        tempthirdParty.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    }
                }
                if (tempDataAccess.length > 0) {
                    this.dataAccess.push({'executors': tempDataAccess, 'category': this.apisByCategory[i]['category']});
                }
                if (tempbusinessLogic.length > 0) {
                    this.businessLogic.push({
                        'executors': tempbusinessLogic,
                        'category': this.apisByCategory[i]['category']
                    });
                }
                if (tempsql.length > 0) {
                    this.sql.push({'executors': tempsql, 'category': this.apisByCategory[i]['category']});
                }
                if (tempworkflow.length > 0) {
                    this.workflow.push({'executors': tempworkflow, 'category': this.apisByCategory[i]['category']});
                }
                if (tempdecision.length > 0) {
                    this.decision.push({'executors': tempdecision, 'category': this.apisByCategory[i]['category']});
                }
                if (tempthirdParty.length > 0) {
                    this.thirdparty.push({'executors': tempthirdParty, 'category': this.apisByCategory[i]['category']});
                }
            }
        });
    }

    getSqlQueryApiExecutorsByPartnerAccountType() {
        if (this.platform.sqlQueryExecutors !== null && this.platform.sqlQueryExecutors !== undefined && this.platform.sqlQueryExecutors !== '') {
            this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
        } else {

            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
                // localStorage.setItem('sqlQueryAPI', JSON.stringify(this.sqlQueryExecutors));
            });

            // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'SQLQUERY').subscribe(data => {
            //     this.sqlQueryExecutors = data;
            //     this.platform.sqlQueryExecutors = data;
            //     localStorage.setItem('sqlQueryAPI', JSON.stringify(this.sqlQueryExecutors));
            // }, error => {
            //     this.platform.openSnackBar('Error while fetching SQL Query APIs', 'Error', {
            //         duration: 5000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
        }
    }

    getWorkFlowApiExecutorsByPartnerAccountType() {
        if (this.platform.workFlowExecutors !== null && this.platform.workFlowExecutors !== undefined && this.platform.workFlowExecutors !== '') {
            this.workFlowExecutors = this.platform.workFlowExecutors;
        } else {
            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.workFlowExecutors = this.platform.workFlowExecutors;
                // localStorage.setItem('workFlowAPI', JSON.stringify(this.workFlowExecutors));
            });
            // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'WORKFLOW').subscribe(data => {
            //     this.workFlowExecutors = data;
            //     this.platform.workFlowExecutors = this.workFlowExecutors;
            //     localStorage.setItem('workFlowAPI', JSON.stringify(this.workFlowExecutors));
            // }, error => {
            //     this.platform.openSnackBar('Error while fetching Workflow APIs.', 'Error', {
            //         duration: 5000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
        }
    }

    getMenu(val) {
        if (val != null) {
            return val.replace(/ /g, '');
        } else {
            return 'Default';
        }

    }

    getEntity(val) {
        const data = val.split('#');
        return data[0];
    }

    getVersion(val) {
        const data = val.split('#');
        return data[1];
    }


    getBackgroundStyle(val) {
        if (val === 'GET') {
            return 'get-method';
        } else if (val === 'PUT') {
            return 'put-method';
        } else if (val === 'POST') {
            return 'post-method';
        } else if (val === 'DELETE') {
            return 'delete-method';
        } else {
            return 'get-method';
        }
    }

    collapsePanel() {
        $('#collapsablePanel').css('display', 'none');
        $('#devexGeneric').removeClass('col-md-9 col-lg-9 col-sm-12 col-xs-12').addClass('col-md-12 col-lg-12 col-sm-12 col-xs-12');
        $('.URL-Field').removeClass('col-lg-9 col-md-9').addClass('col-lg-7 col-md-7');
        this.showAPIBrowser = true;

    }

    selectAPI() {
        $('#collapsablePanel').addClass('col-md-3 col-lg-3 col-sm-12 col-xs-12').css('display', 'block');
        $('#devexGeneric').removeClass('col-md-12 col-lg-12 col-sm-12 col-xs-12').addClass('col-md-9 col-lg-9 col-sm-12 col-xs-12');
        $('.URL-Field').removeClass('col-lg-7 col-md-7').addClass('col-lg-9 col-md-9');
        this.showAPIBrowser = false;


    }


    fetchExecutor(item) {
        this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account, this.getEntity(item), this.getVersion(item)).subscribe(exec => {
            this.executor = exec;
            this.httpUrl = this.executor.apiUrl;
            this.executor_name = this.executor.executor_name;
            this.executor_version = this.executor.executor_version;
            this.executor_type = this.executor.executor_type;
            this.executor_method_type = this.executor.executor_method_type;
            this.httpOperation = this.executor.executor_method_type;
            this.parameterData = this.executor.queryParams;
            this.pathParameter = this.executor.pathParams;
            this.authModel = this.executor.authModel;
            this.headersData = this.executor.headers;
            for (const header of this.headersData) {
                if (header['key'] === 'Content-Type') {
                    switch (header['value']) {
                        case 'multipart/form-data':
                            this.requestBodySelected = 'form-data';
                            this.formData = this.executor.requestBody.value;
                            this.formDataTrue = true;
                            this.formURLEncodedTrue = false;
                            break;
                        case 'application/x-www-form-urlencoded':
                            this.requestBodySelected = 'x-www-form-urlencoded';
                            this.formData = this.executor.requestBody.value;
                            this.formDataTrue = false;
                            this.formURLEncodedTrue = true;
                            break;
                        case 'application/json':
                            this.requestBodySelected = 'raw';
                            this.rawRequestBody = this.executor.requestBody.value;
                            break;
                        default:
                            this.requestBodySelected = 'none';
                            break;
                    }
                }
            }
            this.requestBody = this.executor.requestBody;
            this.executors = this.executor.executors;
            if (this.executor.responseAttributes !== null) {
                this.apiByDefinition = this.executor.responseAttributes;
            }
            this.platform.openSnackBar('Executor selected', 'Success', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }


    //testCases
    deleteAssert(a) {
        this.assert.splice(a, 1);
    }

    deleteTestCase(i) {
        const clickMessage = this.editFlag === true ? 'testsuite_edit_deletetestcase_clicked' : 'testsuite_create_deletetestcase_clicked';

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, clickMessage, 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
            const payloadToSend = {
                actions: response1
            };
            this.testSuiteListenerInstance.testSuiteListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });
        const dialogRef = this.dialog.open(ConfirmTestcaseDeletionComponent, {
            width: '400px',
            data: {name: this.testcase[i].name}
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response && response === 'yes') {
                this.testcase.splice(i, 1);
                this.currentTestCaseIndex = this.currentTestCaseIndex !== 0 ? this.currentTestCaseIndex - 1 : this.currentTestCaseIndex;
                this.currentTestCaseName = this.testcase.length ? this.testcase[this.currentTestCaseIndex].name : '';
                this.Index = this.Index !== 0 ? this.Index - 1 : this.Index;
                // this.platform.openSnackBar('Test Case deleted successfully', 'Success', {
                //     duration: 3000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'center'
                // });
                if (!this.testcase.length) {
                    this.showAPIBrowser = true;
                }
            }
        });
    }

    addAssert() {
        if (this.executor && this.executor !== null) {
            this.leftOperandString = 'API' + '_' + this.executor['executor_name'] + '_' + this.executor['executor_version'] + '>';
            let temp = {
                executor_type: 'logic_compare',
                operator: '',
                leftOperand: {
                    name: 'a',
                    type: 'attributes',
                    field: '',
                    disabled: false
                },
                rightOperand: {
                    executor_type: 'text',
                    field: '',
                    disabled: false
                },
                disabled: false
            };
            this.assert.push(temp);
            this.rightOperandType.push('TEXT');
            this.jsonEditorData.push({});
        } else {
            this.platform.openSnackBar('Please select an executor', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    saveAssert(index) {
    }

    delete(i) {
        this.suite.testcase.splice(i, 1);
    }


    setCurrentTestCase(index) {
        this.currentTestCaseIndex = index;
        this.currentTestCaseName = this.testcase[index].name;
        const currentExecutor = this.testcase[index].testExecutorModel;
        this.assert = this.testcase[index].apiResponseAssertions.rules;
        this.leftOperandString = currentExecutor['executor_type'] + '_' + currentExecutor['executor_name'] + '_' + currentExecutor['executor_version'] + '>';
        if (Object.keys(currentExecutor).length) {
            this.authModel = currentExecutor['authModel'];
            this.headersData = currentExecutor['headers'];
            this.requestBody = currentExecutor['requestBody'];
            this.parameterData = currentExecutor['queryParams'];
            this.pathParameter = currentExecutor['pathParams'];
            this.httpOperation = currentExecutor['executor_method_type'];
            this.httpUrl = currentExecutor['apiUrl'];
            this.executor = currentExecutor;
        } else {
            this.resetAttributes();
        }
        this.getSelectedRequestBodyType();
    }

    resetAttributes() {
        this.httpOperation = '';
        this.httpUrl = '';
        this.headersData = [];
        this.requestBody = {};
    }

    openDialog() {
        const clickMessage = this.editFlag === true ? 'testsuite_edit_addtestcase_clicked' : 'testsuite_create_addtestcase_clicked';


        //this.testCaseName = 'Test Case ' + (this.Index) + 1;
        const dialogRef = this.dialog.open(TestCaseNameInputDialog, {
            width: '300px',
            data: {name: '', type: 'test case'}
        });
        dialogRef.afterClosed().subscribe(name => {
            if (name && name !== '' && name !== ' ') {
                const duplicateTestCases = this.testcase.filter((v, i) => v.name === name);
                if (!duplicateTestCases.length) {
                    this.testCaseName = name;
                    this.currentTestCaseName = name;
                    this.currentTestCaseIndex = this.Index;
                    this.Index = this.Index + 1;
                    this.executor = null;
                    this.addTestCase();
                } else {
                    this.platform.openSnackBar('Test case named ' + name + ' already exists', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.openDialog();
                }

            }
        });
    }

    addTestCase() {
        let temp = {};
        temp['name'] = this.testCaseName;
        temp['description'] = '';
        temp['apiResponseAssertions'] = {
            executor_type: 'logic_operation',
            operand: 'and',
            rules: [],
            disabled: false
        };
        temp['testExecutorModel'] = {};
        this.testcase.push(temp);
        this.assert = [];
        this.resetAttributes();
        this.setCurrentTestCase(this.currentTestCaseIndex);
    }


    getSelectedRequestBodyType() {
        const headers = this.headersData;
        if (!headers.length) {
            this.requestBodySelected = 'none';
            this.rawRequestBody = {};
            this.formData = [];
        }
        for (const header of headers) {
            if (header['key'] === 'Content-Type') {
                switch (header['value']) {
                    case 'multipart/form-data':
                        this.requestBodySelected = 'form-data';
                        this.formData = this.requestBody.value;
                        this.formDataTrue = true;
                        this.formURLEncodedTrue = false;
                        break;
                    case 'application/x-www-form-urlencoded':
                        this.requestBodySelected = 'x-www-form-urlencoded';
                        this.formData = this.requestBody.value;
                        this.formDataTrue = false;
                        this.formURLEncodedTrue = true;
                        break;
                    case 'application/json':
                        this.requestBodySelected = 'raw';
                        this.rawRequestBody = this.requestBody.value;
                        break;
                    default:
                        this.requestBodySelected = 'none';
                        break;
                }
            }
        }
    }

    getRequestBodyValue(val) {
        switch (val) {
            case 'raw':
                // return JSON.stringify(this.editor.get());
                return this.editor.get();
            case 'binary':
            case 'none':
            default:
        }
    }

    getRequestBody() {
        if (this.requestBodySelected === 'raw') {
            const requestbody = {
                'value': this.getRequestBodyValue(this.requestBodySelected),
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'form-data') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'x-www-form-urlencoded') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'none') {
            const requestbody = null;
            return requestbody;
        }
    }

    parameterDataCheck(event: any) {
        // /: calculation
        if (this.devExURL !== event.target.value) {
            this.devExURL = event.target.value;
            this.pathParameterSegregator = this.devExURL.split('/:');
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterStopper = this.pathParameterSegregator[i].split('/');
                this.pathParameterSegregator[i] = this.pathParameterStopper[0];
            }
            // {} for calculation
            let temp2 = this.devExURL.split('/');
            // /: append
            this.pathParameter = [];
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterValue = this.pathParameterSegregator[i];
                this.find = true;
                for (let j = 0; j < this.pathParameter.length; j++) {
                    if (this.pathParameterSegregator[i] === this.pathParameter[j]['key']) {
                        this.find = false;
                    }
                }
                if (this.find === true) {
                    this.pathParameter.push({'key': this.pathParameterValue, 'value': '', 'description': ''});
                }
            }
            // {} append
            for (let i = 2; i < temp2.length; i++) {
                const init = temp2[i].indexOf('{');
                const fin = temp2[i].indexOf('}');
                if ((!(this.pathParameter.some(e => e.key === temp2[i].substr(init + 1, fin - init - 1))) && temp2[i].substr(init + 1, fin - init - 1) !== '') && init !== -1 && fin !== -1) {
                    this.pathParameter.push({
                        'key': temp2[i].substr(init + 1, fin - init - 1),
                        'value': '',
                        'description': ''
                    });
                }
            }
            // confirm to show the path parameter area.
            if (this.pathParameter.length !== 0) {
                this.showPathParameters = true;
            } else {
                this.showPathParameters = false;
            }
        }
    }

    checkQueryParams(event) {
        const tempUrl = event.target.value;
        const seperator = tempUrl.split('/');
        let query: any;
        let finalquery: any;
        if (seperator.length > 0) {
            query = seperator[seperator.length - 1].split('?');
            if (query.length > 1) {
                finalquery = query[query.length - 1].split('&');
                if (finalquery) {
                    for (let i = 0; i < finalquery.length; i++) {
                        let temp = finalquery[i].split('=');
                        let flag = false;
                        for (let j = 0; j < this.parameterData.length; j++) {
                            if (temp[0].includes(this.parameterData[j]['key']) || this.parameterData[j]['key'].includes(temp[0]) || this.parameterData[j]['key'] === temp[0]) {
                                flag = true;
                                if (temp.length > 1) {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = temp[1];
                                } else {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = '';
                                }
                            }
                        }
                        if (flag === false) {
                            if (temp.length > 1) {
                                this.parameterData.push({key: temp[0], value: temp[1], description: ''});
                            } else {
                                this.parameterData.push({key: temp[0], value: '', description: ''});
                            }
                        }
                    }
                }
            }
        }
    }

    async executeApi(context: string) {
        this.executor['requestBody'] = await this.headerChild.getRequestBody();

        const payload = {
            //'executor_name': this.executor_name,
            'executor_type': 'API',
            //'executor_version': this.executor_version,
            'executor_method_type': this.httpOperation,
            'apiUrl': this.httpUrl,
            'dataroot': null,
            'queryParams': this.parameterData,
            'pathParams': this.pathParameter,
            'headers': this.headersData,
            'requestBody': await this.headerChild.getRequestBody(),
            //'executors': this.executors,
            'prerequisites': null
        };

        let temp = this.testcase[this.currentTestCaseIndex];
        temp['testExecutorModel'] = this.executor;
        const assertions = this.assert;
        this.leftOperandString = 'API' + '_' + this.executor['executor_name'] + '_' + this.executor['executor_version'] + '>';
        for (let i = 0; i < this.assert.length; i++) {
            if (assertions[i].leftOperand['field'] === (this.leftOperandString + 'response.statusCode')) {
                assertions[i].rightOperand['executor_type'] = 'math_number';
            }
            if (!assertions[i].leftOperand['field'].includes(this.leftOperandString)) {
                assertions[i].leftOperand['field'] = this.leftOperandString + assertions[i].leftOperand['field'];
                const parser = new DOMParser();
            }
            if (this.rightOperandType[i] === 'JSON') {
                let temp = {
                    disabled: false,
                    executor_type: 'parse_string',
                    value: assertions[i].leftOperand
                };
                assertions[i].leftOperand = temp;
                assertions[i].rightOperand['field'] = JSON.stringify(this.editor.get());
            }
        }

        temp['apiResponseAssertions']['rules'] = assertions;
        this.testcase.splice(this.currentTestCaseIndex, 1, temp);
        this.onAddingTestCase.emit(this.testcase);
        this.onExecutionComplete.emit(context);
        // this.platform.openSnackBar('Testcase added successfully', 'Success', {
        //     duration: 5000,
        //     verticalPosition: 'top',
        //     horizontalPosition: 'center'
        // });
    }

    hasAddTestCasePermission() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['EDIT_TEST_CASE_TEST_SUITE_API', 'edit_test_case:' + this.partner + '=>' + this.account + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('ADD_TEST_CASE_TEST_SUITE_API');
        }
    }

    hasDeleteTestCasePermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['DELETE_TEST_CASE_TEST_SUITE_API', 'delete_test_case:' + this.partner + '=>' + this.account + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('DELETE_TEST_CASE_TEST_SUITE_API');
        }
    }

    hasRulePermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['EDIT_RULE_TEST_SUITE_API', 'edit_rule:' + this.partner + '=>' + this.account + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('ADD_RULE_TEST_SUITE_API');
        }
    }

    hasDeleteRulePermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['DELETE_RULE_TEST_SUITE_API', 'delete_rule:' + this.partner + '=>' + this.account + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('DELETE_RULE_TEST_SUITE_API');
        }
    }

    hasAPIBrowserPermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['SHOW_API_BROWSER_TEST_SUITE_API', 'show_api_browser:' + this.partner + '=>' + this.account + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('SHOW_API_BROWSER_TEST_SUITE_API');
        }
    }

    teardownCompleted(payload) {
        this.onCompletingTearDownSteps.emit(payload);
    }

    toggleExecutorWithID(ev, id) {
        const targetId = 'cat' + id;
        $(targetId).hasClass('in') ? $(targetId).removeClass('in') : $(targetId).addClass('in');
        //$(targetId).slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }

    toggleExecutor(ev) {
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }
}

@Component({
    templateUrl: 'testcasenameinput.component.html'
})
export class TestCaseNameInputDialog {
    constructor(
        public dialogRef: MatDialogRef<TestCaseNameInputDialog>,
        @Inject(MAT_DIALOG_DATA) public data: TestCaseData) {
    }

    onEnterKeyPressed(): void {
        this.dialogRef.close(this.data.name);
    }

}
